/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import Loading from '../../../../components/Loading';
import PageNotFound from '../../../../components/PageNotFound';
import AlertMessage from '../../../../components/AlertMessage';
import PageLayout from '../../../shared/PageLayout';
import { RSVPContext } from '../../context';
import { Title } from '../../styles';
import StepLanding from './stepLanding';
import StepCapture from './stepCapture';
import StepQuestions from './stepQuestions';
import StepConfirmation from './stepConfirmation';
import { LPTitle } from '../../../styles';

const RSVPPageContent = () => {
  const { virtualPhoneNumber, shortId } = useParams();
  const [alertData, setAlertData] = useState({
    open: false,
    handleClose: () => false,
    variant: 'error',
    message: '',
    duration: 3000,
  });
  const {
    contextData: {
      getEventData,
      eventItemLoading,
      eventItemError,
      eventItemData,
      currentStep,
      setCurrentStep,
      setField,
      goToList,
      mutationError,
    },
  } = useContext(RSVPContext);

  useEffect(() => {
    getEventData(shortId);
    setField(shortId, 'eventId');
  }, []);

  useEffect(() => {
    setCurrentStep(0);
  }, [shortId]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setAlertData({ ...alertData, open: false });
  };

  const showError = (error) => {
    const newData = {
      ...alertData,
      open: true,
      message: error,
      handleClose,
    };
    setAlertData(newData);
  };

  useEffect(() => {
    if (mutationError && mutationError.message !== '') {
      showError(mutationError.message);
    }
  }, [mutationError]);

  if (eventItemLoading) {
    return (
      <PageLayout isDark>
        <Loading />
      </PageLayout>
    );
  }

  if (eventItemError) {
    return (
      <PageLayout isDark>
        <LPTitle> Oops! something went wrong: </LPTitle>
        <Title>{eventItemError.message}</Title>
      </PageLayout>
    );
  }

  if (!eventItemData || _.isNull(eventItemData)) {
    return (
      <PageLayout isDark>
        <PageNotFound />
      </PageLayout>
    );
  }

  const {
    getVpn: {
      availableEvents,
      friendlyName,
      account: {
        snapflowTitle,
        description,
        isVerified,
        avatarMedia: {
          uri: avatarUrl,
        },
      },
    },
  } = eventItemData;

  const event = availableEvents[0];
  const splitName = snapflowTitle.split(' ');

  const account = {
    avatarImg: avatarUrl,
    firstName: splitName[0],
    lastName: splitName[1],
    description,
    isVerified,
    extraText: `TEXT ME: ${friendlyName}`,
  };

  const {
    coverMedia,
  } = event;

  const eventCover = coverMedia.video || coverMedia.image;

  const handleBackBtnClick = () => {
    if (currentStep === 0) {
      goToList();
    } else {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <PageLayout
      isDark
      showUserInfo
      coverMedia={eventCover}
      account={account}
      hasBackBtn={currentStep < 3}
      onBackBtnClick={handleBackBtnClick}
    >
      {currentStep === 0 && <StepLanding />}
      {currentStep === 1 && <StepCapture />}
      {currentStep === 2 && <StepQuestions />}
      {currentStep === 3 && <StepConfirmation />}

      <AlertMessage {...alertData} />
    </PageLayout>
  );
};

export default RSVPPageContent;
